import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/tr';
import { blogAPI } from '../services/api';

moment.locale('tr');

const PopularBlogs = React.memo(() => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    const resolveImage = useCallback((img) => {
        if (!img) return '/assets/img/slider/mobil-assistance-slider-1.jpg';
        if (img.startsWith('http')) return img;
        const fileName = img.split('/').filter(Boolean).pop() || img;
        return `/assets/blog/${fileName}`;
    }, []);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await blogAPI.getBlogs();
                const data = response?.data?.data || [];
                const normalized = data.map((item) => ({
                    id: item.idBlog,
                    slug: item.dsSlug,
                    title: item.dsTitle,
                    excerpt: item.dsExcerpt,
                    content: item.dsContent,
                    image: resolveImage(item.dsImage),
                    author: item.dsAuthor,
                    publishDate: item.dtPublishDate || item.dtCreated,
                    category: item.dsCategory,
                    tags: (item.dsTags || '').split(',').map((t) => t.trim()).filter(Boolean),
                    metaDescription: item.dsMetaDescription,
                    metaKeywords: item.dsMetaKeywords,
                    readTime: item.dsReadTime,
                    views: item.mtViews,
                    popular: Boolean(item.flPouplar),
                    created: item.dtCreated,
                }));

                // popüler ve dtPublishDate'e göre en yeni ilk 3
                const popularSorted = normalized
                    .filter((b) => b.popular)
                    .sort((a, b) => {
                        const dateA = new Date(a.publishDate || a.created || 0);
                        const dateB = new Date(b.publishDate || b.created || 0);
                        // Geçersiz tarihleri en alta gönder
                        if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
                        if (isNaN(dateA.getTime())) return 1;
                        if (isNaN(dateB.getTime())) return -1;
                        // En yeni tarihli en üstte (büyükten küçüğe)
                        return dateB.getTime() - dateA.getTime();
                    })
                    .slice(0, 3);

                setBlogs(popularSorted);
            } catch (err) {
                console.error('Blog verisi alınamadı', err);
                setBlogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, [resolveImage]);

    // Resim yükleme hatası için fallback
    const handleImageError = useCallback((e) => {
        e.target.onerror = null; // Sonsuz döngüyü önle
        e.target.src = '/assets/img/slider/mobil-assistance-slider-1.jpg';
    }, []);

    if (loading) {
        return null;
    }

    if (!blogs.length) {
        return null;
    }

    return (
        <section className="standard-section">
            <div className="o-container"> 
                <div className="standard-container">
                    <div className="standard-section-title">
                        <div className="standard-section-title__sub-title" data-aos="fade-up" data-aos-delay="200">
                        BLOG
                        </div>
                        <div className="standard-section-title__main" data-aos="fade-up" data-aos-delay="400">
                            <p className="standard-section-title__main--desc">
                            Araç bakımı, yol güvenliği ve assistance hizmetleri hakkında faydalı bilgiler
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row g-4 mt-4">
                    {blogs.map((post, index) => (
                        <div 
                            key={post.id} 
                            className="col-lg-4 col-md-6" 
                            data-aos="fade-up" 
                            data-aos-delay={index * 100}
                        >
                            <article className="blog-card-home">
                                <Link to={`/tr/blog/${post.slug}`} className="blog-card-image-link">
                                    <div className="blog-card-home-image">
                                        <img 
                                            src={post.image} 
                                            alt={post.title}
                                            loading="lazy"
                                            onError={handleImageError}
                                        />
                                        <div className="blog-card-home-badge">
                                            <i className="fas fa-newspaper me-1"></i>
                                            {post.category}
                                        </div>
                                    </div>
                                </Link>
                                <div className="blog-card-home-content">
                                    <div className="blog-card-home-meta">
                                        <span>
                                            <i className="fas fa-calendar me-1"></i>
                                            {moment(post.publishDate).format('DD MMM YYYY')}
                                        </span>
                                        <span>
                                            <i className="fas fa-clock me-1"></i>
                                            {post.readTime}
                                        </span>
                                    </div>
                                    <Link to={`/tr/blog/${post.slug}`}>
                                        <h3 className="blog-card-home-title">{post.title}</h3>
                                    </Link>
                                    <p className="blog-card-home-excerpt">{post.excerpt}</p>
                                    <div className="blog-card-home-footer">
                                        <Link to={`/tr/blog/${post.slug}`} className="blog-read-more">
                                            Devamını Oku
                                            <i className="fas fa-arrow-right ms-2"></i>
                                        </Link>
                                        <div className="blog-views">
                                            <i className="fas fa-eye me-1"></i>
                                            {post.views}
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-5" data-aos="fade-up">
                    <Link to="/tr/blog" className="modern-cta-button">
                        <i className="fas fa-list me-2"></i>
                        Tüm Blog Yazılarını Gör
                    </Link>
                </div>
            </div>
        </section>
    );
});

PopularBlogs.displayName = 'PopularBlogs';

export default PopularBlogs;

